/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { useTranslation } from '@scuf/localization';
import React from 'react';
import descriptors from '../../../../locales/en-US/descriptors';
import { StrategyStatus } from '../EnergyOptimizationInterfaces';
import EnergyOptimizationLabelTooltip from './EnergyOptimizationLabelTooltip';
import { IAny } from '../../IEnergyManagementProps';

const d: IAny = descriptors.energyManagement;

export interface IEnergyOptimizationStrategyStatusProps {
  strategyStatus: string;
  strategyLastUpdated?: string;
  mainGraph?: boolean;
  toggleEnableEoStatus?: boolean;
}

const EnergyOptimizationStrategyStatus = ({
  strategyStatus,
  strategyLastUpdated,
  mainGraph,
  toggleEnableEoStatus
}: IEnergyOptimizationStrategyStatusProps) => {
  const [t] = useTranslation();
  const strategyElement = (
    <div>
      {toggleEnableEoStatus && !mainGraph && t(d.CURRENTEOSTATUS)}
      <div
        className={`emsop-status-dot ${
          toggleEnableEoStatus
            ? strategyStatus &&
              (t(d[strategyStatus]) as IAny).replaceAll(' ', '-')
            : strategyStatus
        }-status`}
      />
      <span className="emsop-status-text">
        {toggleEnableEoStatus
          ? t(d[strategyStatus])
          : strategyStatus === 'active'
          ? t(d.activeStrategyStatus)
          : t(d.inactiveStrategyStatus)}
      </span>
    </div>
  );

  if (strategyLastUpdated) {
    return (
      <EnergyOptimizationLabelTooltip
        header={t(d.lastUpdated)}
        content={strategyLastUpdated}
        element={strategyElement}
        position="bottom right"
        event="hover"
        size="mini"
      />
    );
  }

  return strategyElement;
};

export default EnergyOptimizationStrategyStatus;
